import { createStore } from "vuex";
let store = createStore({
  state() {
    return {
      productHomeCard: [
        { img: "product-4.jpg", name: "عسل کنار", price: "۸۸۸,۰۰۰" ,priceCalc:"888000" ,id:1},
        { img: "product-7.webp", name: "عسل هزارگل", price: "۴۲۰,۰۰۰" ,priceCalc:"420000" ,id:2},
        { img: "product-2.jpg", name: "عسل آویشن", price: "۱,۳۵۰,۰۰۰" ,priceCalc:"1350000" ,id:4},
        { img: "product-3.jpg", name: "عسل زرشک", price: "۱,۶۴۰,۰۰۰" ,priceCalc:"1640000" ,id:3},
        { img: "product-5.jpg", name: "عسل گشنیز", price: "۸۰۰,۰۰۰" ,priceCalc:"800000" ,id:5},
        { img: "product-1.jpg", name: "عسل گون", price: "۵۵۰,۰۰۰" ,priceCalc:"550000",id:6},
        { img: "product-6.jpg", name: "عسل چهل گیاه", price: "۴۷۰,۰۰۰" ,priceCalc:"470000" ,id:7},
      ],
      commentList:[
        {img:"user-face-1.jpg",name:"امیر حسین حیدری",text:"عرض سلام و وقت بخیر، خیلی ممنونم بابت محصولات خوبتون،محصولات شما در عین اینکه از کیفیت بالایی برخوردار است دارای قیمت مناسبی هم میباشد و این مرا ترغیب کرد تا بیشتر از محصولات شما استفاده کنم."},
        {img:"user-face-2.jpg",name:"سامان اسدی",text:"عرض سلام و وقت بخیر، خیلی ممنونم بابت محصولات خوبتون،محصولات شما در عین اینکه از کیفیت بالایی برخوردار است دارای قیمت مناسبی هم میباشد و این مرا ترغیب کرد تا بیشتر از محصولات شما استفاده کنم."},
        {img:"user-face-3.jpg",name:"هادی باقری",text:"عرض سلام و وقت بخیر، خیلی ممنونم بابت محصولات خوبتون،محصولات شما در عین اینکه از کیفیت بالایی برخوردار است دارای قیمت مناسبی هم میباشد و این مرا ترغیب کرد تا بیشتر از محصولات شما استفاده کنم."},
      ]
    };
  },
  getters:{
    getCommentList(state){
     return state.commentList
    },
    getProductHomeCards(state){
     return state.productHomeCard
    },
    getProductHomeCard(state){
      return function(id){
        return state.productHomeCard.slice(0,id)
      }
    },
    
  }
});
export default store;
